import React from 'react';
import filter from 'lodash/filter';
import includes from 'lodash/includes';

import { InteractiveMap } from '@eb/eds-interactive-map';

import withSearchMapBase from './SearchMapBase';
import BBoxSearchButton from './BBoxSearchButton';
import InteractiveMapMarkerTooltipDesktopWrapped from './interactiveMapMarker/InteractiveMapMarkerTooltipDesktop';
import { GOOGLE_MAPS_CLIENT_KEY } from '../../../../constants';
import {
    INITIAL_MAP_BOUNDS_CHANGE_COUNT,
    SEARCH_MAP_OPTIONS,
    SEARCH_MAP_DESKTOP_MOBILE_PROPTYPES,
} from './constants';

const MAP_TYPE_LOCAL = 'local';

class SearchMapDesktop extends React.PureComponent {
    static propTypes = SEARCH_MAP_DESKTOP_MOBILE_PROPTYPES;

    render() {
        const {
            mapBoundsChangeCount,
            onSearchByBounds,
            markers,
            tooltipSelectedEventsIds,
            events,
            onSaveEvent,
            viewEventMapView,
            isAuthenticated,
            isFixed,
            markerRef,
            isMobile,
            propsForInteractiveMap,
            onClickOutsideMapMarker,
        } = this.props;

        const bboxSearchButtonStyle = {
            margin: '16px 0',
            right: '50%',
            transform: 'translateX(50%)',
        };
        const selectedEvents = filter(events, ({ id }) =>
            includes(tooltipSelectedEventsIds, id),
        );

        return (
            <section>
                <div className="search-map">
                    {mapBoundsChangeCount > INITIAL_MAP_BOUNDS_CHANGE_COUNT && (
                        <BBoxSearchButton
                            style={bboxSearchButtonStyle}
                            onClick={onSearchByBounds}
                        />
                    )}
                    <InteractiveMap
                        {...propsForInteractiveMap}
                        googleMapsClient={GOOGLE_MAPS_CLIENT_KEY}
                        mapType={MAP_TYPE_LOCAL}
                        options={SEARCH_MAP_OPTIONS}
                    >
                        {markers}
                    </InteractiveMap>
                </div>
                <InteractiveMapMarkerTooltipDesktopWrapped
                    selectedEvents={selectedEvents}
                    numEvents={events.length}
                    onSaveEvent={onSaveEvent}
                    onClick={viewEventMapView}
                    isAuthenticated={isAuthenticated}
                    onClickOutside={onClickOutsideMapMarker}
                    parentIsFixed={isFixed}
                    markerRef={markerRef}
                    isMobile={isMobile}
                />
            </section>
        );
    }
}

export default withSearchMapBase(SearchMapDesktop);
